<template>
  <div style="width:100%;height:100%">
    <div class="webPageCenter" id="dddd"></div>
    <div class="kkc-head">
      <div class="kkc-head-left">xxxxxxx</div>
      <div class="kkc-head-center"><div style="width:100%;text-align: center;margin-bottom:0.5vh">科考船3D可视化</div></div>
      <div class="kkc-head-right">xxxxxxx</div>
    </div>
    <div class="kkc-left">
      <div class="left-one">
        <div class="one-title">
          <span>CITY BIG DATA</span>
        </div>
        <div class="one-caveat">
          <div class="caveat red">
            <div
              style="font-size: 12px;float: left;color:#fff;position: relative;left: 3.3vw;top: 0.9vw;"
            >报警</div>
            <div style="font-size: 12px;color:#d20000;position: relative;top: 1vw;left: 1.5vw;">40</div>
          </div>
          <div class="caveat yellow">
            <div
              style="font-size: 12px;float: left;color:#fff;position: relative;left: 3.3vw;top: 0.9vw;"
            >警告</div>
            <div style="font-size: 12px;color:#fcff00;position: relative;top: 1vw;left: 1.5vw;">40</div>
          </div>
          <div class="caveat green">
            <div
              style="font-size: 12px;float: left;color:#fff;position: relative;left: 3.3vw;top: 0.9vw;"
            >安全</div>
            <div style="font-size: 12px;color:#00e7a3;position: relative;top: 1vw;left: 1.5vw;">40</div>
          </div>
        </div>
        <div class="one-table">
          <div class="table-title">
            <div class="table-title-item">CITY BIG DATA</div>
            <div class="table-title-item">CITY BIG DATA</div>
            <div
              class="table-title-item"
              style="text-align: right;margin-right: 10px;"
            >CITY BIG DATA</div>
          </div>
          <ul>
            <li v-for="i in 6" :key="i">
              <span class="sanjiao"></span>
              <span>2020/1/20 14:11 xxxxxxxxxxxxxxxxxx</span>
              <span class="cityBig">CITY BIG</span>
            </li>
            <li class="turnPage">
              <span class="pageUp"></span>
              <span class="page">1/3</span>
              <span class="pageDown"></span>
            </li>
          </ul>
        </div>
      </div>
      <div class="left-two">
        <div class="one-title">
          <span>CITY BIG DATA</span>
        </div>
        <div class="one-caveat" style="height:3.5vh">
          <div v-for="i in 4" :key="i" class="caveat caveatsele">
            <div style="width: 100%;text-align: center;">CITY BIG</div>
          </div>
        </div>
        <div class="one-table" style="height:16vh">
          <ul style="height:11.5vh">
            <li style="display:flex;height:2vh" v-for="i in 4" :key="i">
              <span class="linxing"></span>
              <span>CITY BIG</span>
              <span class="linxing" style="position: absolute;right: 8.2vw;"></span>
              <span style="position: absolute;right: 5vw;">CITY BIG</span>
            </li>
          </ul>
          <div class="caveat caveatsele" style="width:20%;height:3vh;margin-left:5px">
            <div style="width: 100%;text-align: center;">CITY BIG</div>
          </div>
        </div>
      </div>
      <div class="left-three" style=" padding-bottom: 2vh;">
        <div class="one-title">
          <span>CITY BIG DATA</span>
        </div>
        <div id="eOne" ref="homePlatformChart" class="echarOne"></div>
        <div class="bottomButton">
          <div class="cityButton" v-for="i in 6" :key="i">
            <div style="color:#699bff;font-size:12px">CITY</div>
            <div style="color:#fff;font-size:12px;margin-left: 1.1vw;">10000 CI</div>
          </div>
        </div>
      </div>
    </div>
    <div class="kkc-right">
      <div class="right-three">
        <div class="one-title">
          <span>CITY BIG DATA</span>
        </div>
        <!-- <div class="echarOne"></div> -->
        <div style="display:flex">
          <div class="modelpic"></div>
          <div class="bottomButton" style="margin-bottom: 15px;">
            <div class="cityButton" style="width:48%" v-for="i in 4" :key="i">
              <div style="color:#699bff;font-size:12px">CITY</div>
              <div style="color:#fff;font-size:12px;margin-left: 1.1vw;">10000 CI</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-three">
        <div class="one-title">
          <span>CITY BIG DATA</span>
        </div>
        <div class="echarTwo">
          <!-- <img src="../assets/map.png"/> -->
        </div>
        <div class="bottomButton" style="margin-top: 1vh;padding-bottom:1vh">
          <div class="cityButton" v-for="i in 6" :key="i">
            <div style="color:#699bff;font-size:12px">CITY</div>
            <div style="color:#fff;font-size:12px;margin-left: 1.1vw;">10000 CI</div>
          </div>
        </div>
      </div>
      <div class="right-three">
        <div class="one-title">
          <span>CITY BIG DATA</span>
        </div>
        <div id="eThree" ref="homePlatformChartTwo" class="echarOne"></div>
        <div class="bottomButton">
          <div class="cityButton" v-for="i in 3" :key="i" style="margin-top:1vh">
            <div style="color:#699bff;font-size:12px">CITY</div>
            <div style="color:#fff;font-size:12px;margin-left: 1.1vw;">10000 CI</div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialogOne">
      <div class="dialogTitle">CITY BIG DATA</div>
      <ul>
        <li v-for="i in 3" :key="i" style="display:flex">
          <div style="margin-right:2.3vw">
            <div style="text-align: left;color:#5f8fff">CITY</div>
            <div>CITY BIG</div>
          </div>
          <div style="margin-right:2.3vw">
            <div style="text-align: left;color:#5f8fff">CITY</div>
            <div>CITY BIG</div>
          </div>
          <div>
            <div style="text-align: left;color:#5f8fff">CITY BIG DATA</div>
            <div>CITY BIG DATA CITY</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="dialogTwo">
      <div class="dialogTitle">CITY BIG DATA</div>
      <ul>
        <li v-for="i in 4" :key="i" style="display:flex">
          <div style="-webkit-box-flex: 1;-ms-flex-positive: 1;flex-grow: 1;">
            <div style="color:#5f8fff">CITY BIG DATA</div>
            <div>CITY BIG DATA CITY</div>
          </div>
          <div style="-webkit-box-flex: 1;-ms-flex-positive: 1;flex-grow: 1;">
            <div style="color:#5f8fff">CITY BIG DATA</div>
            <div>CITY BIG DATA CITY</div>
          </div>
          <div style="-webkit-box-flex: 1;-ms-flex-positive: 1;flex-grow: 1;">
            <div style="color:#5f8fff">CITY BIG DATA</div>
            <div>CITY BIG DATA CITY</div>
          </div>
          <div style="-webkit-box-flex: 1;-ms-flex-positive: 1;flex-grow: 1;">
            <div style="color:#5f8fff">CITY BIG DATA</div>
            <div>CITY BIG DATA CITY</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="dialogalarm">
      <div class="alarmTitle">报警</div>
      <ul>
        <li v-for="i in 3" :key="i" style="display:flex;padding-bottom:15px">
          <div style="color:#ffa0a0;margin-right:20px">CITY BIG DATA</div>
          <div>CITY BIG DATA</div>
        </li>
      </ul>
      <div class="alarmBottom">
        <div class="line"></div>
        <div class="bottomBtn">
          <div style="margin: 2px;background: red;width:4vw">CITY BIG</div>
        </div>
      </div>
    </div>
    <div class="dialogThree">
      <div class="dialoghead">
        <div class="headTitle">CITY BIG DATA</div>
        <div class="one-caveat" style="height:3.5vh">
          <div v-for="i in 4" :key="i" class="caveat caveatsele">
            <div style="width: 100%;text-align: center;">CITY BIG</div>
          </div>
        </div>
      </div>
      <div class="mySlider">
        <el-slider v-model="value" :marks="marks"></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
import { EleResize } from "../esresize";
export default {
  name: "",
  data() {
    return {
      value: 0,
      marks: {
        5: "CITY BIG",
        20: "CITY BIG",
        30: "CITY BIG",
        20: "CITY BIG",
        40: "CITY BIG",
        60: "CITY BIG",
        70: "CITY BIG",
        80: "CITY BIG",
        90: "CITY BIG",
      },
    };
  },
  mounted() {
    this.drawLine();
    this.drawLine2();
    this.MMS3D_API.clear3D_canvas();
    new this.MMS3D_newCanvas("dddd", function () {
      console.log("done");
    });
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("eOne"));

      // 绘制图表
      const colorList = ["#9E87FF", "#73DDFF", "#fe9a8b", "#F56948", "#9E87FF"];
      let option = {
        backgroundColor: "",
        legend: {
          icon: "rect",
          top: "1%",
          right: "1%",
          itemWidth: 20,
          itemGap: 20,
          textStyle: {
            color: "#556677",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              show: true,
              backgroundColor: "#fff",
              color: "#556677",
              borderColor: "rgba(0,0,0,0)",
              shadowColor: "rgba(0,0,0,0)",
              shadowOffsetY: 0,
            },
            lineStyle: {
              width: 0,
            },
          },
          backgroundColor: "#fff",
          textStyle: {
            color: "#5c6c7c",
          },
          padding: [10, 10],
          extraCssText: "box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)",
        },
        grid: {
          top: "28%",
        },
        xAxis: [
          {
            type: "category",
            data: ["1", "2", "3", "4", "5", "6", "7"],
            axisLine: {
              lineStyle: {
                color: "#21355a",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#556677",
              },
              // 默认x轴字体大小
              fontSize: 12,
              // margin:文字到x轴的距离
              margin: 15,
            },
            axisPointer: {
              label: {
                // padding: [11, 5, 7],
                padding: [0, 0, 10, 0],
                /*
    除了padding[0]建议必须是0之外，其他三项可随意设置
    
    和CSSpadding相同，[上，右，下，左]
    
    如果需要下边线超出文字，设左右padding即可，注：左右padding最好相同
    
    padding[2]的10:
    
    10 = 文字距下边线的距离 + 下边线的宽度
                
    如：UI图中文字距下边线距离为7 下边线宽度为2
    
    则padding: [0, 0, 9, 0]
                
                */
                // 这里的margin和axisLabel的margin要一致!
                margin: 15,
                // 移入时的字体大小
                fontSize: 12,
                backgroundColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      // offset: 0.9,
                      offset: 0.86,
                      /*
0.86 = （文字 + 文字距下边线的距离）/（文字 + 文字距下边线的距离 + 下边线的宽度）
                        
                        */
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.86,
                      color: "#33c0cd", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#33c0cd", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            name: "CITY BIG DATA",
            type: "value",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#21355a",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#3a5587",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            name: "CITY BIG DATA",
            type: "value",
            position: "right",
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "#3a5587",
              },
              formatter: "{value}",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#21355a",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#21355a",
              },
            },
          },
        ],
        series: [
          {
            name: "CITY1",
            type: "line",
            data: [10, 10, 30, 12, 15, 3, 7],
            symbolSize: 1,
            symbol: "circle",
            smooth: true,
            yAxisIndex: 1,
            showSymbol: false,
            lineStyle: {
              width: 5,
              color: "#5860ff",
            },
            itemStyle: {
              normal: {
                color: "#5860ff",
                borderColor: colorList[0],
              },
            },
          },
          {
            name: "CITY2",
            type: "line",
            data: [5, 12, 11, 14, 25, 16, 10],
            symbolSize: 1,
            symbol: "circle",
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 5,
              color: "#3799ff",
            },
            itemStyle: {
              normal: {
                color: "#3799ff",
                borderColor: colorList[1],
              },
            },
          },
        ],
      };

      myChart.setOption(option);
      let listener = function () {
        myChart.resize();
      };
      EleResize.on(this.$refs.homePlatformChart, listener);
    },
    drawLine2() {
      let option = {
        backgroundColor: "",
        tooltip: {
          formatter: "{a} <br/>{c} {b}",
        },
        series: [
          {
            // center: ["50%", "60%"], //仪表的位置
            name: "刻度", //仪表的名字
            type: "gauge", //统计图类型为仪表
            radius: "65%", //统计图的半径大小
            min: 0, //最小刻度
            max: 16, //最大刻度
            splitNumber: 4, //刻度数量
            // startAngle: 225, //开始刻度的角度
            endAngle: 35, //结束刻度的角度
            center: ["17.5%", "60%"],
            axisLine: {
              //设置默认刻度盘上的刻度不显示，重新定义刻度盘
              show: false,
              lineStyle: {
                width: 10,
                color: [
                  [0.7, "#6395f0"],
                  [1, "red"],
                ],
              },
            }, //仪表盘轴线
            axisLabel: {
              //仪表盘上的数据
              show: true,
              // color: "#4d5bd1", //仪表盘上的轴线颜色
              distance: -10, //图形与刻度的间距
            }, //刻度标签。

            axisTick: {
              show: true,
              splitNumber: 6, //刻度的段落数
              lineStyle: {
                width: 2, //刻度的宽度
                color: "auto",
              },
              length: 8, //刻度的长度
            }, //刻度样式
            pointer: {
              width: 4, //指针的宽度
              length: "50%", //指针长度，按照半圆半径的百分比
            },
            itemStyle: {
              //   color: '#18c8ff'
            },
            detail: {
              fontSize: 16,
              width: 30,
              //   color: '#fff',
              rich: {},
              offsetCenter: [0, "35%"],
              //   formatter: function(value) {
              //       return (value * 10 + "%");
              //   }
            },
            data: [{ name: "", value: 3.78 }],
            splitLine: {
              //文字和刻度的偏移量
              show: false,
            }, //分隔线样式
          },
          {
            name: "第二部分",
            type: "gauge",
            color: ["#f00"],
            min: 0,
            max: 8,
            splitNumber: 8,
            radius: "70%",
            center: ["48.5%", "55%"],
            axisLine: {
              // 坐标轴线
              show: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 10,
                color: [
                  [0.7, "#23549a"],
                  [1, "red"],
                ],
              },
              backgroundColor: "none",
            },
            axisTick: {
              show: false,
            },
            tooltip: {
              formatter: function () {
                if (dataArry.two) {
                  return "第二部分:" + dataArry.two;
                }
              },
            },
            splitLine: {
              // 分隔线
              show: false,
            },
            axisLabel: {
              //   fontSize:16,
              //   borderRadius: 1,
              distance: -10,
              //   color: 'rgba(255,255,255,0.7)',
              //   padding: 1,
            },
            title: {
              fontSize: 12,
              fontColor: "#FFF",
              color: "#FFF",
              paddingTop: 10,
              offsetCenter: [0, "90%"],
            },
            itemStyle: {
              //   color: '#1092ff'
            },
            pointer: {
              width: 4, //指针的宽度
              length: "50%", //指针长度，按照半圆半径的百分比
            },
            detail: {
              fontSize: 16,
              width: 30,
              //   color: '#fff',
              rich: {},
              offsetCenter: [0, "35%"],
              //   formatter: function(value) {
              //       return (value * 10 + "%");
              //   }
            },
            data: [
              {
                value: 6,
              },
            ],
          },
          {
            // center: ["50%", "60%"], //仪表的位置
            name: "刻度", //仪表的名字
            type: "gauge", //统计图类型为仪表
            radius: "65%", //统计图的半径大小
            min: 0, //最小刻度
            max: 16, //最大刻度
            splitNumber: 4, //刻度数量
            startAngle: 135, //开始刻度的角度
            // endAngle: -35, //结束刻度的角度
            center: ["77%", "60%"],
            axisLine: {
              //设置默认刻度盘上的刻度不显示，重新定义刻度盘
              show: false,
              lineStyle: {
                width: 10,
                color: [
                  [0.7, "#6395f0"],
                  [1, "red"],
                ],
              },
            }, //仪表盘轴线
            axisLabel: {
              //仪表盘上的数据
              show: true,
              // color: "#4d5bd1", //仪表盘上的轴线颜色
              distance: -10, //图形与刻度的间距
            }, //刻度标签。
            title: {
              fontSize: 12,
              fontColor: "#FFF",
              color: "#FFF",
              paddingTop: 10,
              offsetCenter: [0, "90%"],
            },
            axisTick: {
              show: true,
              splitNumber: 6, //刻度的段落数
              lineStyle: {
                width: 2, //刻度的宽度
                color: "auto",
              },
              length: 8, //刻度的长度
            }, //刻度样式
            pointer: {
              width: 4, //指针的宽度
              length: "50%", //指针长度，按照半圆半径的百分比
            },
            itemStyle: {
              //   color: '#18c8ff'
            },
            detail: {
              fontSize: 16,
              width: 30,
              //   color: '#fff',
              rich: {},
              offsetCenter: [0, "35%"],
              //   formatter: function(value) {
              //       return (value * 10 + "%");
              //   }
            },
            data: [{ name: "", value: 3.78 }],
            splitLine: {
              //文字和刻度的偏移量
              show: false,
            }, //分隔线样式
          },
        ],
      };
      let myChart = this.$echarts.init(document.getElementById("eThree"));
      myChart.setOption(option);
      let listener = function () {
        myChart.resize();
      };
      EleResize.on(this.$refs.homePlatformChartTwo, listener);
    },
  },
};
</script>

<style scoped>
.webPageCenter {
  position: absolute;
  width: 100%;
  height: 100%;
}
.kkc-head {
  position: relative;
  background-image: url("../assets/head.png");
  width: 100%;
  height: 2.7vw;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  color: #97b6ff;
  font-size: 2vh;
}
.kkc-head-left {
  width: 36%;
  text-align: right;
  margin-top: 4px;
}
.kkc-head-center {
  color: #fff;
  font-size: 20px;
  width: 30%;
  display: flex;
  align-items: center;
}
.kkc-head-right {
  width: 36%;
  text-align: left;
  margin-top: 4px;
}
/** 左 */
.kkc-left {
  height: 90vh;
  width: 23vw;
  position: absolute;
}
.left-one {
  background-image: url("../assets/left-bg.png");
  height: auto;
  width: auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.left-two {
  background-image: url("../assets/left-bg.png");
  height: auto;
  width: auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 10px;
}
.left-three {
  background-image: url("../assets/left-bg.png");
  height: auto;
  width: auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 10px;
}
.right-three {
  background-image: url("../assets/right-bg.png");
  height: auto;
  width: auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 10px;
}
.one-title {
  background-image: url("../assets/title.png");
  background-repeat: no-repeat;
  background-size: 5vw 100%;
  height: 2vh;
  font-size: 12px;
  text-align: left;
  color: #7ca8ff;
  display: flex;
  margin-left: 2px;
  align-items: center;
}
.one-caveat {
  display: flex;
  height: 4.3vh;
  padding: 5px;
  width: 22vw;
}
.caveat {
  flex-grow: 1;
  margin-right: 5px;
}
.red {
  background-image: url("../assets/red.png");
  background-size: 100% 100%;
}
.yellow {
  background-image: url("../assets/yellow.png");
  background-size: 100% 100%;
}
.green {
  background-image: url("../assets/green.png");
  background-size: 100% 100%;
}
.one-table {
  height: 23vh;
  width: 22vw;
}
.two-table {
  height: 11vw;
  width: 22vw;
}
.table-title {
  background-image: url("../assets/titlebg.png");
  color: #7ca8ff;
  display: flex;
  align-items: center;
  font-size: 12px;
  height: 2.5vh;
}
.table-title-item {
  flex-grow: 1;
}
.one-table ul {
  margin: 0px;
  height: auto;
  padding: 0px;
}
.one-table li {
  height: 2.4vh;
  list-style: none;
  font-size: 12px;
  color: #fff;
  display: flex;
  align-items: center;
  margin: 4px 0px;
}
.one-table li:nth-child(2) {
  background-image: url("../assets/titlebg.png");
}
.one-table li:nth-child(4) {
  background-image: url("../assets/titlebg.png");
}
.one-table li:nth-child(6) {
  background-image: url("../assets/titlebg.png");
}
.sanjiao {
  width: 15px;
  height: 13px;
  background-image: url("../assets/sanjiao.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0px 15px;
}
.cityBig {
  color: red;
  position: absolute;
  right: 3vw;
}
.pageUp {
  width: 7px;
  height: 9px;
  background-image: url("../assets/pageleft.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pageDown {
  width: 7px;
  height: 9px;
  background-image: url("../assets/pageright.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.turnPage {
  float: right;
  display: flex;
  align-items: center;
}
.page {
  color: #699bff;
  font-size: 12px;
  margin: 0px 32px;
}
.caveatsele {
  background-image: url("../assets/unselected.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #fff;
  text-align: center;
  /* margin-left: 4px; */
}
.linxing {
  width: 30px;
  height: 13px;
  background-image: url("../assets/arrow.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0px 10px;
}
.echarOne {
  height: 11vw;
  width: 22vw;
}
.bottomButton {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 22vw;
  margin-left: 5px;
  height: 9vh;
}
.cityButton {
  width: 30%;
  height: 3.3vh;
  background-image: url("../assets/equipment.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 12px;
}
/** 右 */
.kkc-right {
  height: 90vh;
  width: auto;
  position: absolute;
  right: 0px;
}
.modelpic {
  width: 40%;
  background-image: url("../assets/text.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 1vw;
  height: 6.5vh;
}
.echarTwo {
  height: 30vh;
  background-image: url("../assets/map.png");
  background-size: 70vw 45vw;
  background-repeat: no-repeat;
  background-position-x: -52vw;
  background-position-y: -9vw;
}
/** 弹窗1 */
.dialogOne {
  width: 20vw;
  height: 21vh;
  background-image: url("../assets/boxbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  /* text-align: center; */
  left: 40vw;
  top: 10vh;
  display: none;
}
.dialogTitle {
  color: #fff;
  text-align: left;
  font-size: 14px;
  padding: 10px;
}
.dialogTitle:after {
  content: "";
  background-image: url("../assets/cloes.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 10px;
}
.dialogOne ul {
  padding: 0px;
  margin: 0px;
  font-size: 12px;
}
.dialogOne li {
  padding: 10px;
  color: #c8c8c8;
}
.dialogTwo {
  width: 53vw;
  height: 30vh;
  background-image: url("../assets/boxbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  /* text-align: center; */
  left: 23.5vw;
  top: 10vh;
  display: none;
}
.dialogTwo ul {
  padding: 0px;
  margin: 0px;
  font-size: 12px;
  text-align: left;
}
.dialogTwo li {
  padding: 15px;
  color: #c8c8c8;
}
.dialogalarm {
  width: 19vw;
  height: 19vh;
  background-image: url("../assets/alarmbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  /* text-align: center; */
  left: 40vw;
  top: 10vh;
  display: none;
}
.alarmTitle {
  color: #fff;
  text-align: center;
  font-size: 14px;
  padding: 15px;
}
.dialogalarm ul {
  margin: 0px;
  padding: 0px;
  margin-left: 7vw;
  margin-top: 0.8vh;
}
.dialogalarm li {
  font-size: 12px;
  color: #fff;
}
.alarmTitle:after {
  content: "";
  background-image: url("../assets/cloes.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 10px;
  top: 10px;
}

.dialogalarm ul:after {
  content: "";
  background-image: url("../assets/alarm.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 80px;
  height: 60px;
  position: absolute;
  left: 20px;
  top: 60px;
}
.alarmBottom {
  display: flex;
  align-items: center;
}
.line {
  width: 10vw;
  height: 0.1vh;
  background-color: red;
  margin: 0px 20px;
}
.bottomBtn {
  color: #fff;
  border: 1px red solid;
  font-size: 12px;
}
.dialogThree {
  width: 44vw;
  height: 11vh;
  background-image: url("../assets/boxbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  /* text-align: center; */
  left: 28vw;
  top: 10vh;
  display: none;
}
.dialoghead {
  display: flex;
  align-items: center;
}
.headTitle {
  color: #fff;
  font-size: 12px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: left;
  margin-left: 10px;
}
.mySlider {
  margin: 0px 20px;
}
.mySlider /deep/ .el-slider__button {
  background-color: #409eff;
  width: 12px;
  height: 12px;
}
.mySlider /deep/ .el-slider__runway {
  background-color: #132035;
}
.mySlider /deep/ .el-slider__stop {
  height: 10px;
  width: 1px;
  border-radius: "";
  background-color: #409eff;
}
.mySlider /deep/ .el-slider__marks-text {
  font-size: 10px;
  color: #fff;
}
</style>